import { takeLatest, takeEvery } from 'redux-saga/effects';
import _ from 'lodash';

import {
  fetchJobProfilesRoutine,
  fetchJobProfileRoutine,
  saveJobProfileRoutine,
  removeJobProfileRoutine,
} from '../routines';
import { post, put } from '../../utils/request';

import { fetchSaga, saveSaga, removeSaga } from './helper';
import { getAccountPath } from '../../utils/firebase';

function* watchFetchJobProfilesSaga() {
  yield takeLatest(fetchJobProfilesRoutine.TRIGGER, fetchSaga(fetchJobProfilesRoutine, () => getAccountPath('jobprofiles')));
}

function* watchFetchJobProfileSaga() {
  yield takeLatest(fetchJobProfileRoutine.TRIGGER, fetchSaga(fetchJobProfileRoutine, (payload) => getAccountPath('jobprofiles', payload.id)));
}

function* watchSaveJobProfileSaga() {
  yield takeEvery(saveJobProfileRoutine.TRIGGER, saveSaga(saveJobProfileRoutine,
    (payload) => getAccountPath('jobprofiles', payload.values.get('id')),
    (payload) => payload.values.get('id') ? put : post,
    (payload) => _.pick(payload.values.toJS(), ['name', 'icon', 'description', 'stages', 'relativeTo'])
  ));
}

function* watchRemoveJobProfileSaga() {
  yield takeEvery(removeJobProfileRoutine.TRIGGER, removeSaga(removeJobProfileRoutine,
    (jobProfile) => getAccountPath(`jobprofiles/${jobProfile.id}`)));
}

export {
  watchFetchJobProfilesSaga,
  watchFetchJobProfileSaga,
  watchSaveJobProfileSaga,
  watchRemoveJobProfileSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/jobprofiles.js